import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ScreenQueryServant } from '../servants/screen_query_servant';

export type TScreenDevice = 'mobile' | 'tablet' | 'desktop';

interface IScreenDeviceModel {
  screen_device: TScreenDevice;
}

export type ScreenDeviceModel = ITypedModel<IScreenDeviceModel>;

angular.module('ng-screen-query').factory('ngScreenDeviceModel', (ngScreenQueryServant: ScreenQueryServant) => {
  return new Model<IScreenDeviceModel>({
    screen_device: ngScreenQueryServant.isScreenDesktop() ? 'desktop' : 'mobile'
  });
});



// WEBPACK FOOTER //
// ./app/vendor/screen-query/src/models/screen_device_model.ts